import { API_BASE_LANDINGS } from "@ryde/shared";

export const landingRoutesApiConst = {
  companiesMap: () => `${API_BASE_LANDINGS}/landing/getCompaniesMap`,
  initData: (companyId: number) =>
    `${API_BASE_LANDINGS}/c/${companyId}/landing/getInitialData`,
  profile: (companyId: number) => ({
    fetch: `${API_BASE_LANDINGS}/c/${companyId}/landing-profile`,
    update: `${API_BASE_LANDINGS}/landing-profile`,
  }),
  auth: (companyId: number) => ({
    requestOtpLanding: `${API_BASE_LANDINGS}/c/${companyId}/landing-auth/requestOtp`,
    loginOtpLanding: `${API_BASE_LANDINGS}/c/${companyId}/landing-auth/loginOtp`,
    requestPublicOtpLanding: `${API_BASE_LANDINGS}/c/${companyId}/landing-auth/requestPublicOtp`,
    loginPublicOtpLanding: `${API_BASE_LANDINGS}/c/${companyId}/landing-auth/loginPublicOtp`,
    refreshLanding: `${API_BASE_LANDINGS}/landing-auth/refresh`,
    logoutLanding: `${API_BASE_LANDINGS}/landing-auth/logout`,
  }),
  stations: (companyId: number) => ({
    getOfficialStationsByHomeAddress: `${API_BASE_LANDINGS}/c/${companyId}/landing/getOfficialStationsByHomeAddress`,
    setPassengerPickupStation: `${API_BASE_LANDINGS}/c/${companyId}/landing/setPassengerPickupStation`,
    getDropdownItems: `${API_BASE_LANDINGS}/c/${companyId}/landing/get-stations-dropdown-items`,
  }),
  units: (companyId: number) => ({
    getDropdownItems: `${API_BASE_LANDINGS}/c/${companyId}/landing/get-units-dropdown-items`,
  }),
  sites: (companyId: number) => ({
    getDropdownItems: `${API_BASE_LANDINGS}/c/${companyId}/landing/get-sites-dropdown-items`,
  }),
  courses: (companyId: number) => ({
    getDropdownItems: `${API_BASE_LANDINGS}/c/${companyId}/landing/get-courses-dropdown-items`,
    getStationsByCourse: (courseId: number) =>
      `${API_BASE_LANDINGS}/c/${companyId}/landing/get-stations-by-course/${courseId}`,
    getCampusStations: `${API_BASE_LANDINGS}/c/${companyId}/landing/get-campus-stations`,
  }),
} as const;
